(function () {
  'use strict';

  var METRICS = {
    shipping: 0,
    header: 0,
    bottom: 0
  };

  function getHeaderSection() {
    return document.querySelector('.section-header');
  }

  function updateLayoutMetrics() {
    var shipping = document.querySelector('[data-ww-component="shipping-progress"]');
    var header = document.querySelector('.section-header .header');

    METRICS.shipping = shipping ? shipping.getBoundingClientRect().height : 0;

    if (header) {
      var rect = header.getBoundingClientRect();
      METRICS.header = rect.height;
      METRICS.bottom = rect.bottom;
      document.documentElement.style.setProperty('--ww-header-bottom', Math.round(rect.bottom) + 'px');
      document.documentElement.style.setProperty('--ww-header-height', Math.round(rect.height) + 'px');
    }

    document.documentElement.style.setProperty('--ww-shipping-height', Math.round(METRICS.shipping) + 'px');
  }

  function updateDesktopFit() {
    var section = getHeaderSection();
    var header = document.querySelector('.section-header .header');
    var nav = document.querySelector('.ww-desktop-nav');
    var list = document.querySelector('.ww-desktop-nav__list');

    if (!section || !header || !nav || !list) return;

    if (window.innerWidth < 990) {
      section.classList.remove('ww-header-compact');
      return;
    }

    var available = nav.clientWidth;
    var required = list.scrollWidth;
    var iconsWidth = document.querySelector('.section-header .header__icons');
    var logo = document.querySelector('.section-header .header__heading');

    if (iconsWidth && logo) {
      var headerWidth = header.clientWidth;
      var reserved = logo.offsetWidth + iconsWidth.offsetWidth + 48;
      available = Math.max(0, headerWidth - reserved);
    }

    var compact = required > available + 2;
    section.classList.toggle('ww-header-compact', compact);
  }

  function setMobileOrigin(root) {
    var trigger = root.querySelector('[data-ww-mobile-trigger]');
    var bubble = root.querySelector('[data-ww-mobile-bubble]');

    if (!trigger || !bubble) return;

    var triggerRect = trigger.getBoundingClientRect();
    var bubbleRect = bubble.getBoundingClientRect();
    var x = triggerRect.left + (triggerRect.width / 2) - bubbleRect.left;

    x = Math.max(20, Math.min(bubbleRect.width - 20, x));
    root.style.setProperty('--ww-mobile-origin-x', Math.round(x) + 'px');
  }

  function initMobileNavigation(root) {
    if (!root || root.dataset.wwInitialized === 'true') return;
    root.dataset.wwInitialized = 'true';

    var trigger = root.querySelector('[data-ww-mobile-trigger]');
    var bubble = root.querySelector('[data-ww-mobile-bubble]');
    var backdrop = root.querySelector('[data-ww-mobile-backdrop]');
    var closeButton = root.querySelector('[data-ww-mobile-close]');
    var backButton = root.querySelector('[data-ww-mobile-back]');
    var title = root.querySelector('[data-ww-mobile-title]');
    var searchButton = root.querySelector('[data-ww-mobile-search]');
    var currentPanel = 'root';
    var history = [];
    var activeElement = null;

    if (!trigger || !bubble || !backdrop || !closeButton || !backButton || !title) return;

    function getPanel(id) {
      return root.querySelector('[data-ww-mobile-panel="' + id + '"]');
    }

    function updateChrome() {
      var panel = getPanel(currentPanel);
      var heading = panel ? panel.querySelector('h2') : null;
      title.textContent = currentPanel === 'root'
        ? 'Our Collections'
        : (heading ? heading.textContent.trim() : 'Collections');
      backButton.hidden = currentPanel === 'root';
    }

    function showPanel(id, direction) {
      var nextPanel = getPanel(id);
      var oldPanel = getPanel(currentPanel);

      if (!nextPanel || nextPanel === oldPanel) return;

      if (oldPanel) {
        oldPanel.classList.remove('is-active');
        if (direction === 'back') {
          oldPanel.classList.add('is-leaving');
          window.setTimeout(function () {
            oldPanel.classList.remove('is-leaving');
          }, 260);
        }
      }

      nextPanel.classList.add('is-active');
      currentPanel = id;
      updateChrome();
    }

    function reset() {
      root.querySelectorAll('.ww-mobile-nav__panel.is-active, .ww-mobile-nav__panel.is-leaving').forEach(function (panel) {
        panel.classList.remove('is-active', 'is-leaving');
      });

      var rootPanel = getPanel('root');
      if (rootPanel) rootPanel.classList.add('is-active');
      currentPanel = 'root';
      history = [];
      updateChrome();
    }

    function open() {
      if (root.classList.contains('is-open')) return;

      activeElement = document.activeElement;
      updateLayoutMetrics();
      reset();
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      bubble.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ww-mobile-nav-open');

      window.requestAnimationFrame(function () {
        setMobileOrigin(root);
      });

      window.setTimeout(function () {
        var focusTarget = root.querySelector('.ww-mobile-nav__panel.is-active .ww-mobile-nav__link') || closeButton;
        if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
      }, 260);
    }

    function close() {
      if (!root.classList.contains('is-open')) return;

      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      bubble.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ww-mobile-nav-open');

      window.setTimeout(function () {
        if (activeElement && typeof activeElement.focus === 'function') activeElement.focus();
      }, 340);
    }

    function openNativeSearch() {
      close();
      window.setTimeout(function () {
        var summary = document.querySelector('.header__icons .header__search summary');
        if (summary) summary.click();
      }, 80);
    }

    trigger.addEventListener('click', function () {
      if (root.classList.contains('is-open')) close();
      else open();
    });

    closeButton.addEventListener('click', close);
    backdrop.addEventListener('click', close);

    backButton.addEventListener('click', function () {
      var previous = history.pop();
      if (previous) showPanel(previous, 'back');
    });

    root.addEventListener('click', function (event) {
      var next = event.target.closest('[data-ww-mobile-next]');
      if (!next || !root.contains(next)) return;
      event.preventDefault();
      history.push(currentPanel);
      showPanel(next.getAttribute('data-ww-mobile-next'), 'forward');
    });

    if (searchButton) {
      searchButton.addEventListener('click', function (event) {
        event.preventDefault();
        openNativeSearch();
      });
    }

    root.querySelectorAll('.ww-mobile-nav__link[href], .ww-mobile-nav__footer a, .ww-mobile-nav__intro a').forEach(function (link) {
      link.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (root.classList.contains('is-open') && event.key === 'Escape') close();
    });

    updateChrome();
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return;

    var sections = drawer.getSectionsToRender().map(function (section) {
      return section.id;
    });

    if (!sections.length) return;

    var url = window.location.pathname + '?sections=' + sections.map(function (id) {
      return encodeURIComponent(id);
    }).join(',');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data) return;

        drawer.getSectionsToRender().forEach(function (section) {
          var html = data[section.id];
          if (!html) return;

          var selector = section.selector || '.shopify-section';
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var source = parsed.querySelector(selector);
          var target = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (source && target) target.innerHTML = source.innerHTML;
        });

        if (typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () {});
  }

  function initCartSync() {
    if (document.documentElement.dataset.wwCartSync === 'true') return;
    document.documentElement.dataset.wwCartSync = 'true';

    document.addEventListener('cartUpdate', function () {
      window.setTimeout(refreshCartDrawer, 0);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        window.setTimeout(refreshCartDrawer, 0);
      });
    }
  }

  function boot() {
    updateLayoutMetrics();
    updateDesktopFit();
    initCartSync();

    document.querySelectorAll('[data-ww-mobile-nav]').forEach(function (root) {
      initMobileNavigation(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function () {
    updateLayoutMetrics();
    updateDesktopFit();
    document.querySelectorAll('[data-ww-mobile-nav].is-open').forEach(function (root) {
      setMobileOrigin(root);
    });
  });

  window.addEventListener('scroll', updateLayoutMetrics, { passive: true });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 0);
  });

  document.addEventListener('shopify:section:unload', function () {
    updateLayoutMetrics();
  });

  if (typeof ResizeObserver !== 'undefined') {
    var observer = new ResizeObserver(function () {
      updateLayoutMetrics();
      updateDesktopFit();
    });

    function startObserver() {
      var shipping = document.querySelector('[data-ww-component="shipping-progress"]');
      var header = document.querySelector('.section-header .header');
      var nav = document.querySelector('.ww-desktop-nav');
      if (shipping) observer.observe(shipping);
      if (header) observer.observe(header);
      if (nav) observer.observe(nav);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserver);
    } else {
      startObserver();
    }
  }
}());
